import * as types from './BUMAction_Types'

const headerDropDefData = {
  stateOpt: [],
  selState: '',
  cityOpt: [],
  selCity: '',
  branchOpt: [],
  selBranch: '',
  branchCode: '',
  companyId: ''
}

const initialState = {
  userMasterTableData: [],
  BranchDetailsList: [],
  ModalHeaderDropDownData: headerDropDefData,
  userRollRightTableData: [],
  autoDeactivateUserTblData: [],
  aduCategoryData: [],
  MacRequestsTableData:[],
  MacAuthTableData:[],
  MacMgmtTableData:[],
  // macRequestBranchLst:[]
  MavenUsersTableData:{},
  MavenBranchDetailsTableData:[],
  BranchCommissionForAllData:[],
}
const branchAndUserMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.USER_MASTER_TABLEDATA:
      return { ...state, userMasterTableData: action.data }
    case types.BRANCH_DETAILS:
      return { ...state, BranchDetailsList: action.data }
    case types.UPDATE_MODAL_HEADER_DROPOWN:
      return { ...state, ModalHeaderDropDownData: { ...state.ModalHeaderDropDownData, ...action.data } }
    case types.USERROLLRIGHT_TABLEDATA:
      return { ...state, userRollRightTableData: action.data }
    case types.AUTO_DEACTIVATE_USER_TBLDATA:
      return { ...state, autoDeactivateUserTblData: action.data }
    case types.ADU_CATEGORY_DATA:
      return { ...state, aduCategoryData: action.data }
    case types.MAC_REQUESTS_TABLE_DATA:
      return { ...state, MacRequestsTableData: action.data }
    case types.MAC_AUTH_TABLE_DATA:
      return { ...state, MacAuthTableData: action.data }
    case types.MAC_MGMT_TABLE_DATA:
      return { ...state, MacMgmtTableData: action.data }
    // case types.BRANCH_LIST_CONFIG:
    //   return { ...state, macRequestBranchLst: action.data }
    case types.MAVEN_MGMT_TABLE_DATA:
      return { ...state, MavenUsersTableData: action.data }
    case types.BRANCH_MAC_DETAILS:
      return { ...state, MavenBranchDetailsTableData: action.data }
    case types.BRANCH_COMMISSION_FOR_ALL:
      return { ...state, BranchCommissionForAllData: action.data }
    default:
      return state
  }
}
export default branchAndUserMasterReducer